import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  plan: string;
  minutes: number;
}
const purchases: Purchase[] = [{
  name: 'María L.',
  city: 'Córdoba',
  plan: 'Sistema Completo',
  minutes: 2
}, {
  name: 'Diego V.',
  city: 'Salta',
  plan: 'Plan Premium',
  minutes: 4
}, {
  name: 'Fernanda B.',
  city: 'Neuquén',
  plan: 'Plan Base',
  minutes: 7
}, {
  name: 'Roberto F.',
  city: 'Tucumán',
  plan: 'Sistema Completo',
  minutes: 11
}, {
  name: 'Claudia M.',
  city: 'Mendoza',
  plan: 'Plan Premium',
  minutes: 15
}, {
  name: 'Ricardo S.',
  city: 'Buenos Aires',
  plan: 'Plan Base',
  minutes: 19
}];
export function SocialProofToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // First appearance after a short delay
    const firstShow = setTimeout(() => setVisible(true), 3500);
    return () => clearTimeout(firstShow);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    // Hide current, advance, show next on a loop
    const hideTimer = setTimeout(() => setVisible(false), 5000);
    const cycleTimer = setTimeout(() => {
      setIndex(i => (i + 1) % purchases.length);
      setVisible(true);
    }, 8000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(cycleTimer);
    };
  }, [visible, index, dismissed]);
  if (dismissed) return null;
  const p = purchases[index];
  return <div className="fixed bottom-4 left-4 z-40 pointer-events-none max-w-[calc(100%-2rem)]" data-id="element-250">
      <AnimatePresence mode="wait" data-id="element-251">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: -30,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -30
      }} transition={{
        duration: 0.4
      }} className="pointer-events-auto bg-white rounded-xl shadow-2xl shadow-navy/15 border border-slate-100 p-4 pr-9 w-72 relative" data-id="element-252">
            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-253">
              <X className="w-4 h-4" data-id="element-254" />
            </button>

            <div className="flex items-center gap-2 mb-1.5" data-id="element-255">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-256" />
              <span className="text-[11px] font-bold tracking-wider uppercase text-emerald-600" data-id="element-257">
                Nueva familia unida
              </span>
            </div>

            <p className="text-sm text-navy font-semibold leading-tight" data-id="element-258">
              {p.name}{' '}
              <span className="font-normal text-slate-500" data-id="element-259">de {p.city}</span>
            </p>
            <p className="text-sm text-slate-600" data-id="element-260">
              compró el{' '}
              <span className="font-semibold text-gold-700" data-id="element-261">{p.plan}</span>
            </p>
            <p className="text-[11px] text-slate-400 mt-1.5 uppercase tracking-wide" data-id="element-262">
              Hace {p.minutes} minutos
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}